import _ from "underscore";
import { removeMd5FromStart } from "@exovera/helpers";
import {
	addLineHeightTransform,
	highlightNarrative,
	highlightNarrativeHeader,
	narrativePercentageTransform,
	percentageTransform,
	topicOrNarrativeTransform,
} from "lib/table/tableTransforms.js";

export const defaultCrosstabsNarrativeHeaders = [
	{
		name: "Total",
		id: "totalCount",
		width: 80,
		fixed: true,
		reverseSort: true,
		transform: percentageTransform,
		info: "The percentage of results that contain this narrative",
	},

	{
		name: "Narrative",
		id: "name",
		width: 3,
		fixed: false,
		transform: addLineHeightTransform,
		headerTransform: topicOrNarrativeTransform,
	},
	// {
	// 	name: "Topic",
	// 	id: "parentName",
	// 	width: 150,
	// 	fixed: true,
	// 	transform: addLineHeightTransform,
	// },
];

export const gecCrosstabsHeaders = {
	default: [
		{
			name: "Narrative",
			id: "name",
			width: 3,
			fixed: false,
			transform: addLineHeightTransform,
			// transform: highlightNarrative,
			// headerTransform: highlightNarrativeHeader,
			headerTransform: topicOrNarrativeTransform,
		},
		// {
		// 	name: "Topic",
		// 	id: "parentName",
		// 	width: 150,
		// 	fixed: true,
		// 	transform: addLineHeightTransform,
		// },
		{
			name: "Total",
			id: "totalCount",
			width: 90,
			fixed: true,
			reverseSort: true,
			transform: percentageTransform,
			paddingLeft: 15,
			info: "The percentage of results that contain this narrative",
		},
		{
			name: "Russian",
			id: "Russian",
			width: 70,
			fixed: true,
			reverseSort: true,
			transform: narrativePercentageTransform,
			groupBy: "lang",
		},
		{
			name: "Non-Russian",
			id: "Non-Russian",
			width: 105,
			fixed: true,
			reverseSort: true,
			transform: narrativePercentageTransform,
			groupBy: "lang",
		},
		{
			name: "Independent",
			id: "Kremlin-independent",
			width: 105,
			fixed: true,
			reverseSort: true,
			transform: narrativePercentageTransform,
			groupBy: "alignment",
		},
		{
			name: "Aligned",
			id: "Kremlin-aligned",
			width: 70,
			fixed: true,
			reverseSort: true,
			transform: narrativePercentageTransform,
			groupBy: "alignment",
		},
		{
			name: "Gray/Unknown",
			id: "Grey/Unknown",
			width: 95,
			fixed: true,
			reverseSort: true,
			transform: narrativePercentageTransform,
			groupBy: "alignment",
		},
	],
	country: [
		{
			name: "Narrative",
			id: "name",
			width: 3,
			fixed: false,
			transform: addLineHeightTransform,
			// transform: highlightNarrative,
			// headerTransform: highlightNarrativeHeader,
			headerTransform: topicOrNarrativeTransform,
		},
		// {
		// 	name: "Topic",
		// 	id: "parentName",
		// 	width: 150,
		// 	fixed: true,
		// 	transform: addLineHeightTransform,
		// },
		{
			name: "Total",
			id: "totalCount",
			width: 90,
			fixed: true,
			reverseSort: true,
			transform: percentageTransform,
			paddingLeft: 15,
			info: "The percentage of results that contain this narrative",
		},
		{
			name: "All",
			id: "allMarkets",
			width: 60,
			fixed: true,
			reverseSort: true,
			transform: narrativePercentageTransform,
			paddingLeft: 14,
			groupBy: "country",
		},
		{
			name: "Latvia",
			id: "Latvia",
			width: 60,
			fixed: true,
			reverseSort: true,
			transform: narrativePercentageTransform,
			groupBy: "country",
		},
		{
			name: "Lithuania",
			id: "Lithuania",
			width: 85,
			fixed: true,
			reverseSort: true,
			transform: narrativePercentageTransform,
			groupBy: "country",
		},
		{
			name: "Estonia",
			id: "Estonia",
			width: 70,
			fixed: true,
			reverseSort: true,
			transform: narrativePercentageTransform,
			groupBy: "country",
		},
		{
			name: "Moldova",
			id: "Moldova",
			width: 75,
			fixed: true,
			reverseSort: true,
			transform: narrativePercentageTransform,
			groupBy: "country",
		},
		{
			name: "Russia",
			id: "Russia",
			width: 60,
			fixed: true,
			reverseSort: true,
			transform: narrativePercentageTransform,
			groupBy: "country",
		},
	],
};

export const us2020CrosstabsHeaders = {
	default: [
		{
			name: "Narrative",
			id: "name",
			width: 3,
			fixed: false,
			// transform: highlightNarrative,
			// headerTransform: highlightNarrativeHeader,
			transform: addLineHeightTransform,
			headerTransform: topicOrNarrativeTransform,
		},
		// {
		// 	name: "Topic",
		// 	id: "parentName",
		// 	width: 150,
		// 	fixed: true,
		// 	transform: addLineHeightTransform,
		// },
		{
			name: "Total",
			id: "totalCount",
			width: 90,
			fixed: true,
			reverseSort: true,
			transform: percentageTransform,
			// headerTransform;
			paddingLeft: 15,
			info: "The percentage of results that contain this narrative",
		},
		{
			name: "Left",
			id: "Left",
			width: 60,
			fixed: true,
			reverseSort: true,
			transform: narrativePercentageTransform,
			groupBy: "bias",
		},
		{
			name: "Left-Center",
			id: "Left-Center",
			width: 95,
			fixed: true,
			reverseSort: true,
			transform: narrativePercentageTransform,
			groupBy: "bias",
		},
		{
			name: "Least",
			id: "Least",
			width: 60,
			fixed: true,
			reverseSort: true,
			transform: narrativePercentageTransform,
			groupBy: "bias",
		},
		{
			name: "Right-Center",
			id: "Right-Center",
			width: 105,
			fixed: true,
			reverseSort: true,
			transform: narrativePercentageTransform,
			groupBy: "bias",
		},
		{
			name: "Right",
			id: "Right",
			width: 60,
			fixed: true,
			reverseSort: true,
			transform: narrativePercentageTransform,
			groupBy: "bias",
		},
	],
	stateLeaning: [
		{
			name: "Narrative",
			id: "name",
			width: 3,
			fixed: false,
			// transform: highlightNarrative,
			// headerTransform: highlightNarrativeHeader,
			transform: addLineHeightTransform,
			headerTransform: topicOrNarrativeTransform,
		},
		// {
		// 	name: "Topic",
		// 	id: "parentName",
		// 	width: 150,
		// 	fixed: true,
		// 	transform: addLineHeightTransform,
		// },
		{
			name: "Total",
			id: "totalCount",
			width: 90,
			fixed: true,
			reverseSort: true,
			transform: percentageTransform,
			// headerTransform;
			paddingLeft: 15,
			info: "The percentage of results that contain this narrative",
		},
		{
			name: "Left",
			id: "Left",
			width: 60,
			fixed: true,
			reverseSort: true,
			transform: narrativePercentageTransform,
			groupBy: "stateLeaning",
		},
		{
			name: "Right",
			id: "Right",
			width: 70,
			fixed: true,
			reverseSort: true,
			transform: narrativePercentageTransform,
			groupBy: "stateLeaning",
		},
		{
			name: "Battleground",
			id: "Battle",
			width: 110,
			fixed: true,
			reverseSort: true,
			transform: narrativePercentageTransform,
			groupBy: "stateLeaning",
		},
	],
};

export const defaultConfigureStats = (params) => {
	const {
		leftBargraphTop,
		leftBargraphTopMiddle,
		leftBargraphMiddle,
		leftBargraphBottomMiddle,
		leftBargraphBottom,
		rightBargraphTop,
		rightBargraphMiddle,
		rightBargraphBottom,
	} = params;

	return (
		leftBargraphTop ||
		leftBargraphTopMiddle ||
		leftBargraphMiddle ||
		leftBargraphBottomMiddle ||
		leftBargraphBottom ||
		rightBargraphTop ||
		rightBargraphMiddle ||
		rightBargraphBottom
	);
};

export const configureGECStats = (params) => {
	const { leftBargraphMiddle, leftBargraphBottom } = params;

	const splitLanguage = _.partition(leftBargraphBottom, (lang) => {
		return removeMd5FromStart({ string: lang.id }) === "Russian";
	});

	const notRussianScoreArray = _.pluck(splitLanguage[1], "value");
	const notRussianTotal = notRussianScoreArray.reduce((a, b) => a + b, 0);

	const russian = splitLanguage[0][0];
	const notRussian = {
		name: "Non-Russian",
		label: "Non-Russian",
		id: "Non-Russian",
		parent: "entities",
		type: "Language",
		value: notRussianTotal,
	};

	return [...leftBargraphMiddle, russian, notRussian];
};

export const futureHeaders = [];
